import React from 'react';
import { Box, Typography, Paper, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, MenuItem, Chip, IconButton, Tooltip, TextField } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

// Mock Data
const initialEmployees = [
    { id: 'EMP001', name: 'Sarah Jenkins', role: 'SENIOR DEV', dept: 'Engineering', rating: 4.8, band: 'Band B', assigned: true },
    { id: 'EMP002', name: 'Michael Chen', role: 'PM', dept: 'Product', rating: 4.2, band: null, assigned: false },
    { id: 'EMP003', name: 'Jessica Alba', role: 'DEV', dept: 'Engineering', rating: 3.5, band: null, assigned: false },
    { id: 'EMP004', name: 'David Smith', role: 'ACCOUNT EXEC', dept: 'Sales', rating: 2.9, band: null, assigned: false },
    { id: 'EMP005', name: 'Emma Wilson', role: 'LEAD DESIGNER', dept: 'Design', rating: 4.9, band: null, assigned: false },
    { id: 'EMP006', name: 'Robert Brown', role: 'PM', dept: 'Product', rating: 3.8, band: null, assigned: false },
];

const PerformanceBandAssignment = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ p: 1 }}>
            <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                <TextField fullWidth placeholder="Search name or ID..." size="small" />
                <TextField select value="All" size="small" sx={{ width: 180 }}>
                    <MenuItem value="All">All</MenuItem>
                </TextField>
            </Box>

            <TableContainer component={Paper} sx={{ borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.04)', overflow: 'hidden', border: '1px solid #E2E8F0', bgcolor: '#FFFFFF' }}>
                <Box sx={{ overflowX: 'auto' }}>
                    <Table sx={{ minWidth: 900 }}>
                        <TableHead sx={{ bgcolor: '#EFF6FF' }}>
                            <TableRow>
                                <TableCell sx={{ color: '#1D4ED8', fontWeight: 700, borderBottom: '1px solid #E5E7EB' }}>Employee</TableCell>
                                <TableCell sx={{ color: '#1D4ED8', fontWeight: 700, borderBottom: '1px solid #E5E7EB' }}>Department</TableCell>
                                <TableCell sx={{ color: '#1D4ED8', fontWeight: 700, borderBottom: '1px solid #E5E7EB' }}>Rating</TableCell>
                                <TableCell sx={{ color: '#1D4ED8', fontWeight: 700, borderBottom: '1px solid #E5E7EB' }}>Band</TableCell>
                                <TableCell sx={{ color: '#1D4ED8', fontWeight: 700, borderBottom: '1px solid #E5E7EB' }} align="right">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ bgcolor: '#FFFFFF' }}>
                            {initialEmployees.map((emp) => (
                                <TableRow key={emp.id} hover sx={{
                                    '&:hover': {
                                        bgcolor: '#F1F5F9 !important'
                                    }
                                }}>
                                    <TableCell sx={{ color: '#1E293B' }}>
                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{emp.name}</Typography>
                                        <Typography variant="caption" color="text.secondary">{emp.id} • {emp.role}</Typography>
                                    </TableCell>
                                    <TableCell sx={{ color: '#1E293B' }}>
                                        <Chip label={emp.dept} size="small" sx={{ borderRadius: 1, bgcolor: '#F1F5F9' }} />
                                    </TableCell>
                                    <TableCell sx={{ color: '#1E293B' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                            <Typography variant="body2" sx={{ fontWeight: 700, color: '#F59E0B' }}>★</Typography>
                                            <Typography variant="body2">{emp.rating}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ color: '#1E293B' }}>
                                        {emp.band ? (
                                            <Chip label={emp.band} size="small" color="primary" variant="outlined" sx={{ fontWeight: 600 }} />
                                        ) : (
                                            <Typography variant="caption" sx={{ color: '#CBD5E1', fontStyle: 'italic' }}>Unassigned</Typography>
                                        )}
                                    </TableCell>
                                    <TableCell sx={{ color: '#1E293B' }} align="center">
                                        <Tooltip title="View Details">
                                            <IconButton size="small">
                                                <Visibility fontSize="small" onClick={() => navigate('/manager//band-assignment/view')} />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </TableContainer>
        </Box>
    );
};

export default PerformanceBandAssignment;